import { useEffect, useRef, useState } from "react"

import { refreshD2cStaticAssets } from "./refreshD2cStaticAssets.js"

// Eager bootstrap fallback: the journey never mounted, so there are no editable fields or saves to flush.
export function D2cPageLoadRecovery() {
  const mounted = useRef(true)
  const pending = useRef(false)
  const [busy, setBusy] = useState(false)
  const [reloadFailed, setReloadFailed] = useState(false)
  useEffect(() => {
    mounted.current = true
    return () => { mounted.current = false }
  }, [])

  const reload = async () => {
    if (pending.current) return
    pending.current = true
    setBusy(true)
    setReloadFailed(false)
    const selectedUrl = window.location.href
    try {
      await refreshD2cStaticAssets()
    } catch {
      // Best effort only: an asset refresh failure must not prevent an explicit native reload.
    }
    if (!mounted.current) return
    if (window.location.href !== selectedUrl) {
      pending.current = false
      setBusy(false)
      return
    }
    try {
      window.location.reload()
    } catch {
      pending.current = false
      setBusy(false)
      setReloadFailed(true)
    }
  }

  // Inline essentials keep this usable when a stylesheet was among the failed assets.
  return (
    <main style={{ minHeight: "100vh", padding: "32px 20px", background: "#f8fafc", color: "#273653", fontFamily: "system-ui, sans-serif" }}>
      <div style={{ maxWidth: "480px", margin: "40px auto", lineHeight: 1.5 }}>
        <h1 style={{ fontSize: "24px", lineHeight: 1.25 }}>We couldn&apos;t load your application</h1>
        <p role="status" aria-live="polite">Reload to try again. Your application link will be kept.</p>
        <button type="button" disabled={busy} aria-busy={busy} onClick={reload} style={{ padding: "12px 20px", border: 0, borderRadius: "8px", background: "#0a5c9e", color: "white", fontSize: "16px", cursor: busy ? "wait" : "pointer" }}>
          {busy ? "Reopening application..." : "Reload application"}
        </button>
        {reloadFailed && <p role="alert">Please try reloading again.</p>}
      </div>
    </main>
  )
}
